import { toast } from 'react-toastify'
import { switchMap, filter, debounceTime, map } from 'rxjs/operators'
import { EMPTY, of } from 'rxjs'
import { isActionOf } from 'typesafe-actions'
import { WsEventType } from '@sparling/financial-common'
import {
  setAuthToken,
  transactionStatusUpdated,
  unsetAuthToken,
  userBalanceUpdated,
  userBaseCurrencyUpdated,
  userExternalWalletStatusUpdated,
  wsConnected,
} from '../actions'
import { RootEpic } from '../types'

export const connect: RootEpic = (action$, state$, { ws }) => {
  return action$.pipe(
    filter(isActionOf(setAuthToken)),
    debounceTime(200),
    switchMap(({ payload }) => {
      if (!ws.isConnected && process.env.REACT_APP_WS_API_URL) {
        ws.connect(process.env.REACT_APP_WS_API_URL, payload)
      }

      return of(wsConnected())
    }),
  )
}

export const disconnect: RootEpic = (action$, state$, { ws }) => {
  return action$.pipe(
    filter(isActionOf(unsetAuthToken)),
    switchMap(() => {
      if (ws.isConnected) {
        ws.disconnect()
      }

      return EMPTY
    }),
  )
}

export const subscribeToUserBaseCurrencyUpdatedEventsEpic: RootEpic = (action$, state$, { ws }) => {
  return action$.pipe(
    filter(isActionOf(wsConnected)),
    switchMap(() =>
      ws.on$(WsEventType.USER_BASE_CURRENCY_UPDATED).pipe(map((event) => userBaseCurrencyUpdated(event.currency))),
    ),
  )
}

export const subscribeToExternalWalletStatusUpdatedEventsEpic: RootEpic = (action$, state$, { ws }) => {
  return action$.pipe(
    filter(isActionOf(wsConnected)),
    switchMap(() =>
      ws.on$(WsEventType.USER_EXTERNAL_WALLET_STATUS_UPDATED).pipe(
        map((event) => {
          toast.info('External wallet status updated.')
          return userExternalWalletStatusUpdated(event)
        }),
      ),
    ),
  )
}

export const subscribeToUserTransactionUpdatedEventsEpic: RootEpic = (action$, state$, { ws }) => {
  return action$.pipe(
    filter(isActionOf(wsConnected)),
    switchMap(() =>
      ws.on$(WsEventType.USER_TRANSACTION_STATUS_UPDATED).pipe(
        map((event) => {
          toast.success(`Transaction [${event.transactionId}] status updated to ${event.status}.`)
          return transactionStatusUpdated(event)
        }),
      ),
    ),
  )
}

export const subscribeToUserBalanceUpdatedEventsEpic: RootEpic = (action$, state$, { ws }) => {
  return action$.pipe(
    filter(isActionOf(wsConnected)),
    switchMap(() =>
      ws.on$(WsEventType.USER_BALANCE_UPDATED).pipe(
        map((event) => {
          toast.success(`${event.asset} balance updated to ${event.balance}.`)
          return userBalanceUpdated(event)
        }),
      ),
    ),
  )
}

export default [
  connect,
  disconnect,
  subscribeToUserBaseCurrencyUpdatedEventsEpic,
  subscribeToExternalWalletStatusUpdatedEventsEpic,
  subscribeToUserTransactionUpdatedEventsEpic,
  subscribeToUserBalanceUpdatedEventsEpic,
]
